import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Mujeres de 40 a 55 años que se sienten inflamadas y agotadas.', 'Quienes notan un aumento de grasa abdominal que no cede con dieta.', 'Mujeres que sufren de insomnio, niebla mental o cambios de humor repentinos.', 'Aquellas que buscan una base científica pero práctica para entender su transición.'];
  const notFor = ['Personas que buscan una "pastilla mágica" sin cambiar hábitos básicos.', 'Quienes esperan resultados de pérdida de peso extrema en 24 horas.', 'Hombres o mujeres menores de 35 años (su química hormonal es distinta).'];
  return <section className="py-20 bg-white" data-id="element-221">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-222">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-223">
          {/* Is For */}
          <FadeIn direction="right" data-id="element-224">
            <div className="bg-sage-light/30 p-8 rounded-3xl border border-sage-light h-full" data-id="element-225">
              <h3 className="text-2xl font-bold text-forest mb-8 flex items-center gap-3" data-id="element-226">
                <CheckCircle2 className="text-sage w-8 h-8" data-id="element-227" />
                Esto ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-228">
                {isFor.map((item, index) => <li key={index} className="flex gap-4 items-start" data-id="element-229">
                    <CheckCircle2 className="text-sage w-6 h-6 flex-shrink-0 mt-1" data-id="element-230" />
                    <span className="text-forest/80 text-lg" data-id="element-231">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For */}
          <FadeIn direction="left" delay={0.2} data-id="element-232">
            <div className="bg-red-50/50 p-8 rounded-3xl border border-red-100 h-full" data-id="element-233">
              <h3 className="text-2xl font-bold text-forest mb-8 flex items-center gap-3" data-id="element-234">
                <XCircle className="text-red-400 w-8 h-8" data-id="element-235" />
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-236">
                {notFor.map((item, index) => <li key={index} className="flex gap-4 items-start" data-id="element-237">
                    <XCircle className="text-red-400 w-6 h-6 flex-shrink-0 mt-1" data-id="element-238" />
                    <span className="text-forest/80 text-lg" data-id="element-239">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}